import React, { useCallback, useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import axiosInstance from "../../../utils/axiosInstance";
import { useSelector } from "react-redux";

const WhatsappSupport = () => {
  const userInfo = useSelector((state) => state.userStore);
  const allowAutoDeposit = !!userInfo.data?.allow_auto_deposit;

  const [whatsappNo, setWhatsappNo] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState({ text: "", isError: false });

  const loadWhatsappNumber = useCallback(async () => {
    setLoading(true);
    setMessage({ text: "", isError: false });
    try {
      const response = await axiosInstance.get("/company/whatsapp-support");
      if (response.data?.status) {
        setWhatsappNo(response.data.data?.whatsapp_no || "");
      } else {
        setWhatsappNo("");
      }
    } catch {
      setWhatsappNo("");
      setMessage({
        text: "Failed to load WhatsApp number",
        isError: true
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadWhatsappNumber();
  }, [loadWhatsappNumber]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmed = whatsappNo.trim();
    if (!trimmed) {
      setMessage({
        text: "WhatsApp number is required",
        isError: true
      });
      return;
    }

    setSaving(true);
    setMessage({ text: "", isError: false });
    try {
      const response = await axiosInstance.post("/company/whatsapp-support", {
        whatsapp_no: trimmed
      });
      if (response.data?.status) {
        setWhatsappNo(response.data.data?.whatsapp_no || trimmed);
        setMessage({
          text:
            response.data.message ||
            "WhatsApp support number saved successfully",
          isError: false
        });
      } else {
        setMessage({
          text: response.data?.message || "Failed to save WhatsApp number",
          isError: true
        });
      }
    } catch (error) {
      setMessage({
        text:
          error?.response?.data?.message || "Failed to save WhatsApp number",
        isError: true
      });
    } finally {
      setSaving(false);
    }
  };

  return (
    <AgentLayout>
      <div className="container-fluid">
        <div className="bets-section-wrapper">
          <NavButton />

          <div className="row">
            <div className="col-12 col-md-8 col-lg-6">
              <form onSubmit={handleSubmit}>
                <div className="card">
                  <div className="card-header d-flex align-items-center">
                    <MessageCircle
                      size={18}
                      strokeWidth={2}
                      style={{ marginRight: 8 }}
                    />
                    <strong className="site_family">Whatsapp Support</strong>
                  </div>
                  <div className="card-body">
                    <p
                      className="site_family"
                      style={{ fontSize: "13px", color: "#555" }}
                    >
                      Add or update the WhatsApp phone number your clients can
                      use to reach you for support.
                    </p>

                    {loading ? (
                      <div className="site_family">Loading...</div>
                    ) : (
                      <div className="form-group row">
                        <label
                          className="col-12 col-md-4 col-form-label site_family"
                          htmlFor="whatsappNo"
                        >
                          WhatsApp Number
                        </label>
                        <div className="col-12 col-md-8">
                          <input
                            id="whatsappNo"
                            type="tel"
                            className="form-control site_family"
                            placeholder="e.g. +923001234567"
                            value={whatsappNo}
                            onChange={(e) => setWhatsappNo(e.target.value)}
                            disabled={saving}
                          />
                          <small
                            className="form-text text-muted site_family"
                            style={{ fontSize: "12px" }}
                          >
                            Enter your WhatsApp number including country code
                            (e.g. +923001234567).
                          </small>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="card-footer editsbmtbtn">
                    <button
                      className="btn btn-success editsbmtbtnin site_family"
                      type="submit"
                      disabled={loading || saving}
                      style={{ background: "#02b181", borderColor: "#28a745" }}
                    >
                      <strong>{saving ? "Saving..." : "Save"}</strong>
                    </button>
                    {message.text ? (
                      <div
                        className={`mt-2 site_family ${
                          message.isError ? "text-danger" : "text-success"
                        }`}
                        style={{ fontSize: "13px" }}
                      >
                        {message.text}
                      </div>
                    ) : null}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default WhatsappSupport;
